// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"99":"bambuser-handler","506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] || chunkId) + "." + {"99":"d4fbb515","280":"27105966","506":"9102114b","536":"a8b52a6b","889":"ea438e80"}[chunkId] + ".js";
};